<div class="relative w-full">
  <div
    #reference
    class="border-default bg-surface flex max-h-60 flex-wrap gap-2 overflow-y-auto rounded-lg border p-2">
    @for (entry of entries(); track entry.key; let i = $index) {
      <div
        class="border-default bg-elevated flex items-center gap-2 rounded px-2 py-1 text-sm">
        <span class="text-text-primary font-medium">{{ entry.key }}</span>
        <span class="text-text-tertiary">=</span>

        @switch (valueTypeFor(entry.key)) {
          @case (LabelValueType.BOOL) {
            <input
              type="checkbox"
              [id]="id() + '-value-' + i"
              [checked]="entry.value === 'true'"
              (change)="updateValue(i, $any($event.target).checked ? 'true' : 'false')"
              class="accent-accent-main h-4 w-4 cursor-pointer" />
          }
          @case (LabelValueType.NUMBER) {
            <input
              type="number"
              [id]="id() + '-value-' + i"
              [value]="entry.value"
              (input)="updateValue(i, $any($event.target).value)"
              (blur)="onInputBlur()"
              placeholder="{{ 'form.value' | translate }}"
              class="border-default bg-elevated text-text-primary placeholder-text-tertiary focus:border-accent-focus focus:ring-accent-focus w-24 rounded border px-2 py-0.5 text-sm outline-none focus:ring-1" />
          }
          @case (LabelValueType.REFERENCE) {
            <div class="min-w-[160px]">
              <app-entity-auto-complete
                [id]="id() + '-value-' + i"
                [entityType]="referencedEntityTypeFor(entry.key)"
                [isArray]="false"
                [value]="entry.value"
                [ngModel]="entry.value"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="updateValue(i, $any($event))" />
            </div>
          }
          @case (LabelValueType.ENUM) {
            <app-select
              class="w-32"
              [id]="id() + '-value-' + i"
              [items]="enumVariantsFor(entry.key)"
              [value]="$any(entry.value) ?? null"
              [placeholder]="'form.value' | translate"
              (valueChange)="updateValue(i, $any($event))"
              (touchedChange)="onInputBlur()" />
          }
          @default {
            <input
              type="text"
              [id]="id() + '-value-' + i"
              [value]="entry.value"
              (input)="updateValue(i, $any($event.target).value)"
              (blur)="onInputBlur()"
              placeholder="{{ 'form.value' | translate }}"
              class="border-default bg-elevated text-text-primary placeholder-text-tertiary focus:border-accent-focus focus:ring-accent-focus w-32 rounded border px-2 py-0.5 text-sm outline-none focus:ring-1" />
          }
        }

        <button
          type="button"
          (click)="removeEntry(i)"
          class="ml-1 inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-full text-zinc-500 opacity-80 hover:text-red-600 hover:opacity-100 dark:text-zinc-400 dark:hover:text-red-300">
          <svg class="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    }
    <input
      type="text"
      class="text-text-primary placeholder-text-tertiary min-w-[120px] flex-1 border-0 bg-transparent text-sm outline-none focus:ring-0"
      [id]="id()"
      [placeholder]="'form.labels_placeholder' | translate"
      [value]="searchText()"
      (keydown)="onKeyDown($event)"
      (blur)="onInputBlur()"
      (focus)="onInputFocus()"
      (input)="onSearchInput($event)" />
  </div>

  @if (isDropdownOpen()) {
    <div
      #dropdown
      data-testid="labels-dropdown"
      class="border-default bg-elevated fixed top-0 left-0 z-500 max-h-60 overflow-auto rounded-lg border shadow-lg">
      @for (label of filteredOptions(); track label.id; let i = $index) {
        <div
          (click)="addLabel(label)"
          (keydown.enter)="addLabel(label)"
          [class.bg-interactive]="i === highlightedIndex()"
          class="text-text-primary hover:bg-interactive flex cursor-pointer items-center justify-between gap-2 px-4 py-2.5 text-sm">
          <span>{{ label.label }}</span>
          <span class="text-text-tertiary text-xs uppercase">{{ label.valueType }}</span>
        </div>
      } @empty {
        <div class="text-text-tertiary px-4 py-2.5 text-sm">
          {{ 'common.no_items' | translate }}
        </div>
      }
    </div>
  }
</div>
